export const environment = {
	production: true,
	env: 'PROD',
	baseUrl: ''
};
